import { ErrorBoundary } from 'react-error-boundary'
import { SamlAuthRequiredFallback } from '@/components/error-boundaries/fallbacks/saml-auth-required-fallback'
import { SamlSessionGuard } from '@/components/error-boundaries/saml-session-guard'
import { SamlAuthRequiredError } from '@/lib/errors'
import { useIdCompany } from '@/lib/hooks'

export const SamlSessionBoundary = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { idCompany } = useIdCompany()

  return (
    <ErrorBoundary
      key={idCompany}
      fallbackRender={({ error }) => {
        const isSamlAuthRequired =
          error.name === 'SamlAuthRequiredError' ||
          error instanceof SamlAuthRequiredError

        if (isSamlAuthRequired) {
          return <SamlAuthRequiredFallback error={error} />
        }
        throw error
      }}
    >
      <SamlSessionGuard />
      {children}
    </ErrorBoundary>
  )
}
